var StyleCssUtils;
((StyleCssUtils2) => {
  StyleCssUtils2.getPropertyValue = (valueName, config) => {
    return config.window.getComputedStyle(config.el).getPropertyValue(valueName);
  };
  StyleCssUtils2.setPropertyValue = (valueName, value, el) => {
    el.style.setProperty(valueName, value);
  };
  StyleCssUtils2.getComputedStyle = (config) => {
    return config.window.getComputedStyle(config.el);
  };
  StyleCssUtils2.getPropertyEntries = (config) => {
    const variables = /* @__PURE__ */ new Set();
    let targetElement = config.el;
    if (!config.el) {
      targetElement = config.window.document.documentElement;
      Array.from(config.window.document.styleSheets).forEach((sheet) => {
        try {
          Array.from(sheet.cssRules).forEach((rule) => {
            if ("style" in rule && rule.style instanceof CSSStyleDeclaration) {
              Array.from(rule.style).filter((prop) => prop.startsWith("--")).forEach((prop) => variables.add(prop));
            }
          });
        } catch (e) {
          console.warn("\uC2A4\uD0C0\uC77C\uC2DC\uD2B8 \uC811\uADFC \uC81C\uD55C:", e);
        }
      });
    }
    const computedStyles = config.window.getComputedStyle(targetElement);
    Array.from(computedStyles).filter((prop) => prop.startsWith("--")).forEach((it) => {
      variables.add(it);
    });
    return Array.from(variables).map((it) => [it, computedStyles.getPropertyValue(it)]);
  };
})(StyleCssUtils || (StyleCssUtils = {}));
export {
  StyleCssUtils
};
//# sourceMappingURL=StyleCssUtils.js.map
